import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

import { ShareArticleSection } from "../ShareArticleSection";

const AmazonConnectLaunchPlustGenAIChatBot = () => {
  return (
    <div className="modal-content-body case-studies-blk">
      <div className="modal-section">
        <div className="flex-content header-modal-case-studies">
          <div className="logo-section-modal">
            <img
              src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/thumbnails/stb-thumbnail-iris.png"
              alt="Scene to believe"
            />
          </div>
          <div>
            <h3>Amazon Connect Launch + GenAI Chatbot</h3>
            <p>
              Scene to Believe Delivers Magical Experiences with AI-Powered
              Omnichannel Contact Centre
            </p>
            <ShareArticleSection />
          </div>
        </div>
      </div>

      {/* Opportunity & Qualification */}
      <div className="modal-section">
        <h2 className="modal-section-title">Company Snapshot:</h2>
        <p className="title-description-blk">
          Scene to Believe is one of Australia's leading providers of event
          photography and visual activation experiences, operating nationwide
          across shopping centre activations, corporate and community events,
          and large seasonal campaigns. The team is best known for orchestrating
          over 500 Santa locations every Christmas, capturing and sharing
          magical memories for thousands of families every year.{" "}
        </p>
      </div>

      {/* Proposed Solution */}
      <div className="modal-section">
        <div className="flex-content-half">
          <div>
            <h2 className="modal-section-title">Challenge:</h2>
            <p>
              With customer interactions ramping up dramatically during the
              festive season, Scene to Believe struggled with a fragmented
              support stack, spread across RingCentral for calls and Freshdesk
              for tickets, as well as manual workflows, limited self-service,
              and poor reporting capabilities. Reliance on legacy platforms made
              scaling for seasonal peaks expensive and left both customers and
              staff without modern AI-powered service, workforce tools, or
              unified reporting.
            </p>
          </div>
          <div>
            <h2 className="modal-section-title">AWS Solution:</h2>
            <p>
              CXeed partnered with Scene to Believe to consolidate all customer
              channels - voice, email, and chat - onto Amazon Connect's true
              omnichannel cloud platform. Using Amazon Bedrock, the “Elf-bot” AI
              self-service agent was launched, instantly solving customer
              queries and automating repetitive interactions. With the shift to
              the Unlimited AI Bundle, Scene to Believe benefited from auto QA,
              Amazon Contact Lens for compliance and sentiment, Amazon Q for
              real-time agent assist, and advanced analytics via Amazon
              QuickSight.
            </p>
          </div>
        </div>
      </div>

      <div className="outcomes-result-blk">
        <h2 className="modal-section-title">Outcomes/Results:</h2>
        <ul>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>
                70% reduction in voice channel support costs, enabling
                cost-effective scaling for seasonal peaks.
              </p>
            </div>
          </li>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>
                50% uplift in CSAT due to shorter response times and always-on
                intelligent self-service.
              </p>
            </div>
          </li>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>
                Streamlined omnichannel workflows, delivering seamless support
                across all digital and voice touchpoints.
              </p>
            </div>
          </li>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>
                High-impact analytics, auto QA, and real-time insights for
                continuous improvement and compliance.
              </p>
            </div>
          </li>
        </ul>
      </div>

      <div className="modal-footnote use-cases-footnote" style={{ border: 0 }}>
        <h4>Client Testimonial</h4>
        <h1>
          “Our experience working with iCXeed has been really positive.
          Together, we're developing some exciting AI-driven innovations on the
          AWS platform that are helping us take customer experience to the next
          level.”
        </h1>
        <div className="flex-box-blk client-details">
          <div>
            <img
              src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/steffan-hutton.png"
              alt="Stefan Hutton"
            />
          </div>
          <div>
            <h2>Stefan Hutton</h2>
            <p>Managing Director</p>
            <p>Scene to Believe</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AmazonConnectLaunchPlustGenAIChatBot;
